<div class="common-modal__container">
  <div class="common-modal__header">
    <span [afTranslate]="'send-reminder.title'"
      class="common-modal__text-header">
      _Enviar recordatorio
    </span>
  </div>
  <span
    class="common-modal__content-header-info"
    [afTranslate]="'send-reminder.subtitle'">
    _¿A qué destinatarios quieres enviar un recordatorio de la reunión?
  </span>
  <div class="common-modal__form-container-row">
    <button
      (click)="send(0)"
      class="common-button-card__container-action">
      <div class="common-button-card__title-container-action">
        <div
          [afTranslate]="'send-reminder.pending-confirm'"
          class="common-button-card__inner-title-action">
          _Pendientes de confirmación
        </div>
        <i class="lf-icon-question common-icon__xl">
        </i>
      </div>
      <span
        [afTranslate]="'send-reminder.info-pending'"
        class="common-button-card__description">
        _Se enviará el recordatorio a las personas que todavía no han aceptado o rechazado la convocatoria de reunión.
      </span>
    </button>
    <button
      (click)="send(1)"
      class="common-button-card__container-action">
      <div class="common-button-card__title-container-action">
        <div
          [afTranslate]="'send-reminder.all-participants'"
          class="common-button-card__inner-title-action">
          _Todos los asistentes
        </div>
        <i class="lf-icon-group common-icon__xl">
        </i>
      </div>
      <span
        [afTranslate]="'send-reminder.info-all-participants'"
        class="common-button-card__description">
        _Se enviará el recordatorio a todas las personas invitadas, excepto las que ya han rechazado la convocatoria.
      </span>
    </button>
  </div>
  <div class="common-modal__footer">
    <button
      (click)="handleDismiss()"
      class="common-button__text">
      <span
        [afTranslate]="'common.close'"
        class="common-button__text-title">
      </span>
    </button>
  </div>
</div>
